import GriffinNumber from 'griffin-paypal/lib/client/number';
import { store } from '../../../framework/store/configureStore';
import _ from 'lodash';

let griffinNumberHandler;

// Annual Income of 0 is allowed in PayPal Credit Application
const MIN_ANNUAL_INCOME = 0;
// Maximum Annual Income value allowed is 9999999
const MAX_ANNUAL_INCOME = 9999999;
// Use this pattern to replace all chars but numbers and '.'s
const ANNUAL_INCOME_PATTERN = /[^0-9.]/g;

function getHandler() {
    if (!griffinNumberHandler) {
        const storeState = store.getState();
        griffinNumberHandler = GriffinNumber.createHandler(storeState.serverData.localityMetadata);
    }

    return griffinNumberHandler;
}

export const normalizeSelfReportedIncome = (value, isActive) => {
    const griffinNumberHandler = getHandler();
    const griffinNumberOptions = griffinNumberHandler.NUMBER_FORMAT;
    griffinNumberOptions.maximumFractionDigits = 0;

    if (isActive) {
        if ((value || value === '0')) {
            value = value.replace(/\D/g, '');
            if (value !== '') {
                value = griffinNumberHandler.formatNumber(value, griffinNumberOptions);
            }
            return `$ ${value}`;
        } else {
            return '$ ';
        }
    } else if (value === '$ ') {
        return '';
    }
};

// Check that the Field has numbers (currency values)
export const isNonNumeric = (msg) => (value) => {
    if (!value.match(/\d/g)) {
        return {
            msg,
            className: 'hasError'
        };
    }
};

/** Check that the Field does not take any value > 9999999 or < 0
 * The griffin formatter should not let decimal digits to be entered.
 * If somehow, the income gets decimal digits, then it would be stripped off on the server side controller before sending it in ACQSERV request payload.
 * The normalizeSelfReportedIncome and formatNumber function are activated before this function and therefore the value is prefixed w/ '$ ' and has commas where applicable.
 * @param error msg
 * @param value to be validated
 * @return error object if value is invalid OR undefined if value is invalid
 */
export const isValidAnnualIncome = (msg) => (value) => {
    if (!value) {
        return {
            msg,
            className: 'hasError'
        };
    }
    const income = parseFloat(value.replace(ANNUAL_INCOME_PATTERN, ''));
    // parseFloat on all blanks or empty string would result in NaN, lodash isEmpty returns true for any number value and wouldn't help in this case.
    if (_.isNaN(income) || income < MIN_ANNUAL_INCOME || income > MAX_ANNUAL_INCOME) {
        return {
            msg,
            className: 'hasError'
        };
    }
};


